import get from 'lodash.get';

export const selectRecurrentCart = (state) => get(state, 'recurrentCart');

export const selectRecurentCartData = (state) => get(state, 'recurrentCart.data', []);
